module.exports = __webpack_public_path__ + "img/veteran_grunt_small.a7ef238a.png";